import { Box, Grid } from "@mui/material";
import { FormikProps } from "formik";
import CustomTitle from "../../../../../../../../../components/app/CustomTitle";
import CustomTextArea from "../../../../../../../../../components/CustomTextArea";
import Text from "../../../../../../../../../components/Text";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";
import CbtCognitiveDistortions from "./CbtCognitiveDistortions";
import DbtComponents from "./DbtComponents";
import ActComponents from "./ActComponents";

const MODALITY_CBT = "Cognitive_Behavioral_Therapy_CBT";
const MODALITY_DBT = "Dialectical_Behavior_Therapy_DBT";
const MODALITY_ACT = "Acceptance_Commitment_Therapy_ACT";

interface ModalitySpecificComponentsProps {
  primaryModality: string;
  formik?: FormikProps<Form2Payload>;
}

const ModalitySpecificComponents = ({
  primaryModality,
  formik,
}: ModalitySpecificComponentsProps) => {
  if (!formik || !primaryModality) return null;

  if (primaryModality === MODALITY_CBT) {
    return (
      <Grid item xs={12}>
        <Box>
          <Text variant="subtitle1" fontWeight={600} mb={2}>
            CBT-Specific Components
          </Text>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTextArea
                label="CBT specific components"
                rows={3}
                placeholder="CBT specific components"
                value={
                  formik.values?.psychotherapyCbtVisitNote
                    ?.cbtSpecificComponents ?? ""
                }
                onChange={(e) =>
                  formik.setFieldValue(
                    "psychotherapyCbtVisitNote.cbtSpecificComponents",
                    e.target.value
                  )
                }
              />
            </Grid>
            {/* <Grid item xs={12}>
              <CustomTextArea
                label="Automatic Thoughts Identified"
                rows={3}
                placeholder="Key automatic thoughts identified during session"
                value={formik.values?.cbtAutomaticThoughts ?? ""}
                onChange={(e) =>
                  formik.setFieldValue("cbtAutomaticThoughts", e.target.value)
                }
              />
            </Grid> */}
            <Grid item xs={12}>
              <CustomTitle>Cognitive Distortions Identified</CustomTitle>
            </Grid>
            <CbtCognitiveDistortions formik={formik} />
            {/* <Grid item xs={12}>
              <CustomTextArea
                label="Behavioral Experiments/Exposure Work"
                rows={3}
                placeholder="Behavioral activation, exposure exercises, or experiments conducted"
                value={formik.values?.cbtBehavioralExperiments ?? ""}
                onChange={(e) =>
                  formik.setFieldValue(
                    "cbtBehavioralExperiments",
                    e.target.value
                  )
                }
              />
            </Grid> */}
          </Grid>
        </Box>
      </Grid>
    );
  }

  if (primaryModality === MODALITY_DBT) {
    return <DbtComponents formik={formik} />;
  }

  if (primaryModality === MODALITY_ACT) {
    return <ActComponents formik={formik} />;
  }

  return null;
};

export default ModalitySpecificComponents;
